import { SET_APP_TITLE } from "../../../constants/MainConstants";

export default function setAppTitleAction(appTitle: string) {
    return {
        type: SET_APP_TITLE,
        appTitle
    };
}
